import API from 'services/api';

export interface IParsedAirbnbInvoice {
  description: string;
  confirmationCode: string;
  invoiceDate: string;
  invoiceNumber: string;
  amount: number;
  currencyCode: string;
  missingFields: string[];
}

export const parseAirbnbInvoice = ({
  calculationId,
  file,
}: {
  calculationId: string;
  file: File;
}): Promise<IParsedAirbnbInvoice> => {
  const formData = new FormData();
  formData.append('File', file);

  return API.post(`api/accommodation/calculations/${calculationId}/airbnbInvoice/parse`, formData, {
    headers: { 'Content-Type': 'multipart/form-data;' },
  }).then(response => response?.data);
};
